import { Component, OnChanges, OnInit, Input } from '@angular/core';
import { EChartsOption } from 'echarts';
import {
	THEME_COLOR_BLUE,
	THEME_COLOR_MAIN
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
@Component({
	selector: 'app-travel-distance-by-user',
	templateUrl: './travel-distance-by-user.component.html',
	styleUrls: ['./travel-distance-by-user.component.scss']
})
export class TravelDistanceByUserComponent implements OnChanges {
	travelDistance: EChartsOption;
	@Input() statsEmployee: any = [];
	userNameArray = []; //Tableau des noms des employés
	distanceArray = []; //Tableau des distances parcourures

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	constructor(private facade: FacadeService) {
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
	}
	// ngOnInit(): void {}
	ngOnChanges(change: any) {
		this.updateUserName();
		if (isNaN(this.statsEmployee)) {
			this.updateChart();
		}
	}

	updateChart() {
		const xAxisData = this.userNameArray;
		this.travelDistance = {
			tooltip: {
				formatter: '<strong>{b}</strong> : {c} Kms'
			},
			xAxis: {
				name: 'Employé',
				type: 'category',
				data: xAxisData.map((empName: string) => {
					return { value: empName, textStyle: { color: THEME_COLOR_MAIN } };
				}),
				nameLocation: 'middle',
				nameGap: 50,
				nameTextStyle: { color: THEME_COLOR_MAIN }
			},
			yAxis: {
				name: 'Distance parcourue en Km',
				type: 'value',
				nameLocation: 'middle',
				nameGap: 100,
				nameTextStyle: { color: THEME_COLOR_MAIN },
				axisLabel: {
					color: THEME_COLOR_MAIN
				}
			},
			series: [
				{
					data: this.distanceArray,
					type: 'bar',
					showBackground: false,
					color: THEME_COLOR_BLUE
				}
			]
		};
	}

	updateUserName() {
		if (isNaN(this.statsEmployee)) {
			try {
				this.userNameArray = this.statsEmployee
					.filter((item) => item.fullName !== 'Total')
					.map((item) => {
						return item.fullName;
					});
				this.distanceArray = this.statsEmployee
					.filter((item) => item.fullName !== 'Total')
					.map((item) => {
						return item.distanceParcourue / 1000;
					});
			} catch (error) {}
		}
	}
}
